import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import readableFileSize from 'filesize';
import { useDeviationAttributes } from '../../../../_partials/hooks/useDeviationAttributes';
import { DownloadType } from '../utils';
import DownloadOption from '../DownloadOption';
import { useFlag } from '../../../../../redux/flags/hooks';
import { formatDollars } from '../../../../../utils/formatting';
import s from './DownloadOptions.scss';
var DownloadOptions = function (_a) {
    var _b;
    var pcp = _a.pcp, download = _a.download, deviation = _a.deviation, onSelect = _a.onSelect, selectedType = _a.selectedType;
    var t = useTranslation().t;
    var newPriceFormat = useFlag('new_price_format');
    // The case for being an owner and both download and pcp being available is undefined,
    // so just default the owner arg here to false
    var isDownloadable = useDeviationAttributes(deviation, false).isDownloadable;
    var fileTypesIncluded = ((pcp && pcp.assets) || [])
        .map(function (asset) { return asset.type && asset.type.toLocaleUpperCase(); })
        .filter(function (type, index, array) { return type && array.indexOf(type) === index; })
        .join(' ');
    var dollarPrice = newPriceFormat
        ? formatDollars(pcp === null || pcp === void 0 ? void 0 : pcp.downloadDollarPrice)
        : "$" + ((_b = pcp === null || pcp === void 0 ? void 0 : pcp.downloadDollarPrice) !== null && _b !== void 0 ? _b : '');
    var titleWithPrice = pcp
        ? t(!newPriceFormat || (pcp.downloadPrice && pcp.downloadPrice < 80)
            ? 'pcp.buyForPoints'
            : 'pcp.buyForCurrency', {
            price: pcp.downloadPrice,
            dollars: dollarPrice,
        })
        : '';
    return (React.createElement("div", { className: classnames(s['checkboxes']) },
        isDownloadable && download && (React.createElement(DownloadOption, { value: DownloadType.FREE, title: t('pcp.free', {
                size: download.width + "x" + download.height,
            }), onChange: onSelect, isChecked: selectedType === DownloadType.FREE })),
        pcp && (React.createElement(DownloadOption, { value: DownloadType.PREMIUM, title: pcp.hasUserPurchased ? t('pcp.purchased') : titleWithPrice, subtitle: t('pcp.zipFileDetails', {
                size: readableFileSize(pcp.zipFilesize || 0),
                types: fileTypesIncluded,
            }), onChange: onSelect, isChecked: selectedType === DownloadType.PREMIUM }))));
};
DownloadOptions.displayName = 'DownloadOptions';
export default DownloadOptions;
//# sourceMappingURL=DownloadOptions.js.map